import React from 'react';
import { useTranslation } from 'react-i18next';
import { Form, FormikContextType, FormikProvider } from 'formik';
import SideFormActions from '../../../../../components/createEditComponents/SideFormActions';
import FormikTextField from '../../../../../components/formikComponents/FormikTextField';
import FormikCheckbox from '../../../../../components/formikComponents/FormikCheckbox';

const CategoriesForm = ({
  formik,
  cancelAction,
  objectId,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formik: FormikContextType<any>;
  cancelAction: () => void;
  objectId: string;
}) => {
  const { t } = useTranslation();

  return (
    <FormikProvider value={formik}>
      <Form onSubmit={formik.handleSubmit}>
        <FormikTextField
          label={t('screens.products.sidekick.import.productsTable.name')}
          id="name"
          required
          invalidPattern={/[#']/g}
          objectId={objectId}
          name="name"
        />
        <FormikCheckbox
          label={t('screens.products.sidekick.import.productsTable.wetDry')}
          id="isWet"
          name="isWet"
          type="checkbox"
          objectId={objectId}
        />
        <SideFormActions cancelAction={cancelAction} />
      </Form>
    </FormikProvider>
  );
};
export default CategoriesForm;
